import { useMemo } from 'react';
import { LandingPage } from './pages/LandingPage';
import { FaqPage } from './pages/FaqPage';
import { BlogPage } from './pages/BlogPage';

const App = () => {
  const pathname = useMemo(() => (typeof window !== 'undefined' ? window.location.pathname : '/'), []);

  if (pathname === '/faq') {
    return <FaqPage />;
  }

  if (pathname.startsWith('/blog')) {
    return <BlogPage />;
  }

  return <LandingPage />;
};

export default App;
